
<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="searchListWrap other">
            <div class="center_text">
              <h5 class="period">검사일: {{getCertificateLookupDetail.requestDate}}</h5>
              <div class="inBtnWrap">
                <h5 class="period"><b>{{getCertificateLookupDetail.state | setState}}</b>상태입니다.</h5>
              </div>
            </div>
          </div>
<!--          <div class="center_text lookup">-->
<!--            <p>검사일: {{getCertificateLookupDetail.requestDate}}</p>-->
<!--            <p>상태: <b :class="{red : getCertificateLookupDetail.state === 0}">{{getCertificateLookupDetail.state | setState}}</b></p>-->
<!--          </div>-->
          <div class="label_wrap full request lookup">
            <div class="lw_item_wrap width-100">
              <div class="lw_item" v-for="c in getCertificateLookupDetail.list" :key="c.id" :class="{lookupDetailNone: c.detail === null}">
                <label class="type">
                  <div class="lw_textWrap request">
                    <div class="lw_left">
                      <p class="nameVal">{{c.name}}</p>
                      <p class="detailVal">{{c.detail}}</p>
                    </div>
                    <div class="lw_right">
                      <p class="priceVal">{{c.price | plusComma}}원</p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="center_text pb-50 lookup">
            <p>신청하신 서류의 장 수에 따라 </p>
            <p>금액은 변동될 수 있습니다.</p>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
          <button type="button" class="callTerms" @click="moveList()">목록</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import EventBus from '@/utils/bus'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '제증명 발급 신청 내역',
        prevUrl: '/certificateLookupList'
      }
    }
  },
  computed: {
    ...mapGetters('certificate', [
      'getCertificateLookupDetail'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions('certificate', [
      'CERTIFICATE_LOOKUP_DETAIL'
    ]),
    moveList () {
      if (sessionStorage.getItem('pathFromLoadUnAuth').indexOf('certificateLookupList') !== 1) {
        this.$router.push('/certificateLookupList')
      } else {
        history.go(-1)
      }
    },
    async fetchData () {
      try {
        const code = Number(this.$route.params.certificateIssuanceId)
        await this.CERTIFICATE_LOOKUP_DETAIL(code)
          .then(() => {
            console.log('code:', code)
          })
      } catch (error) {
        console.log('error :', error);
        console.log('제증명 발급 신청내역 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    callPrev () {
      const currentLocation = document.location.href.split('/')
      const mainLocate = '/' + currentLocation[3] + '/' + currentLocation[4]
      console.log('메인로케이트', mainLocate)
      console.log('setCount', this.setCount)
      /*      if (sessionStorage.getItem('pathToLoadUnAuth') === mainLocate) {
        this.setCount++
        if (this.setCount === 2) {
        }
      } */
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    console.log('난 실행안하나요?')
    this.fetchData()
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    EventBus.$off('pageAccess')
  },
  filters: {
    plusComma (val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setState (val) {
      if (val === 0) {
        return String(val).replace('0', '신청')
      } else if (val === 1) {
        return String(val).replace('1', '발급완료')
      } else if (val === 2) {
        return String(val).replace('2', '수령완료')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
